"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function pick(a, keysToPick) {
    var result = {};
    var keys = Object.keys(a);
    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
        var key = keys_1[_i];
        if (keysToPick.indexOf(key) !== -1 && a.hasOwnProperty(key)) {
            result[key] = a[key];
        }
    }
    return result;
}
exports.pick = pick;
